import { Box } from "@mui/material";
import clsx from "clsx";
import OverviewFooter, { OverviewFooterProps } from "../../../common/OverviewFooter/OverviewFooter";
import { OverviewIntegrationOption, OverviewIntegrations } from "../Integrations/OverviewIntegrations";
import styles from "./ConsoleOverviewLayout.module.scss";

interface Props {
	className?: string;
	copyApiTokenProps: OverviewFooterProps;
	integrations?: OverviewIntegrationOption[];
	pageName?: string;
	children: React.ReactNode;
	onFigmaClick?: () => void;
	onPhotoshopClick?: () => void;
	onFigmaPluginDownload?: () => void;
	onPhotoshopPluginDownload?: () => void;
	onComfyUClick?: () => void;
	onFalClick?: () => void;
	onInvokeClick?: () => void;
	onAWSClick?: () => void;
	onAzureClick?: () => void;
}

const ConsoleOverviewLayout = ({
	copyApiTokenProps,
	integrations,
	children,
	className,
	pageName,
	onFigmaClick,
	onPhotoshopClick,
	onFigmaPluginDownload,
	onPhotoshopPluginDownload,
	onComfyUClick,
	onFalClick,
	onInvokeClick,
	onAWSClick,
	onAzureClick,
}: Props) => {
	return (
		<Box className={clsx(styles.layout, className)}>
			<Box className={styles.overview}>
				<OverviewFooter className={styles.footer} {...copyApiTokenProps} />
				{children}
			</Box>
			{integrations && (
				<OverviewIntegrations
					className={styles.integrations}
					cards={integrations}
					pageName={pageName}
					onFigmaClick={onFigmaClick}
					onPhotoshopClick={onPhotoshopClick}
					onFigmaPluginDownload={onFigmaPluginDownload}
					onPhotoshopPluginDownload={onPhotoshopPluginDownload}
					onComfyUClick={onComfyUClick}
					onFalClick={onFalClick}
					onInvokeClick={onInvokeClick}
					onAWSClick={onAWSClick}
					onAzureClick={onAzureClick}
				/>
			)}
		</Box>
	);
};

export default ConsoleOverviewLayout;
